import { FieldProps, FieldRenderProps } from 'react-final-form';

import { TextInputField } from '../../../UIPackage/MainModule/components/TextInputField';
import { ITextInputProps } from '../../../UIPackage/MainModule/components/TextInput';

type Value = ITextInputProps['value'];
type IKnmSnilsFieldProps = ITextInputProps & FieldProps<Value, FieldRenderProps<Value>>;

export const KnmSnilsField = ({ ...props }: IKnmSnilsFieldProps) => {
  const normalizeSnils = (value: string | undefined) => {
    if (!value) return value;
    const onlyNums = value.replace(/\D/g, '');
    let resultValue = onlyNums.slice(0, 3);

    if (onlyNums.length > 3) resultValue += `-${onlyNums.slice(3, 6)}`;
    if (onlyNums.length > 6) resultValue += `-${onlyNums.slice(6, 9)}`;
    if (onlyNums.length > 9) resultValue += ` ${onlyNums.slice(9, 11)}`;

    return resultValue;
  };

  return <TextInputField {...props} parse={normalizeSnils} />;
};
